window.HegydGtm = {

    pushToDatalayer : function (gtm) {
        window.dataLayer = window.dataLayer || [];
        if(typeof dataLayer !== 'undefined') {
            // Envoi des données à GTM
            Object.keys(gtm).forEach(function(k){
                dataLayer.push(gtm[k]);
            });
        }
    },

    initEvents: function () {
        $('body').on('click','a.see-more-product',function (e) {
            e.preventDefault();
            var $this = $(this);

            HegydCore.sendRequest($this.data('href'),'POST',{ 'product_id' : $this.data('id') },function (data) {
                HegydGtm.pushToDatalayer(data.gtm);
                window.location.href = $this.attr('href');
            })
        })
    },

    init: function () {
        HegydGtm.initEvents();
    }
};

(function ($) {
    HegydGtm.init();
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/vendor/hegyd-core/js/hegyd-gtm.js